import ScrollReveal from "../components/ScrollReveal";
import PortfolioGrid from "../components/sections/PortfolioGrid";
import StatsMarquee from "../components/sections/StatsMarquee";
import CTASection from "../components/sections/CTASection";

export default function PortfolioPage() {
  return (
    <div data-testid="portfolio-page">
      <section className="pt-36 md:pt-44 pb-16 md:pb-24 border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-10">
          <ScrollReveal>
            <div className="text-xs uppercase tracking-[0.4em] text-white/40 mb-4">
              / Portfolio
            </div>
            <h1 className="font-display text-5xl md:text-7xl font-black uppercase tracking-tighter leading-[0.95]">
              The work<br /><span className="text-white/40">speaks loudest.</span>
            </h1>
            <p className="mt-6 text-white/60 max-w-2xl text-base md:text-lg leading-relaxed">
              A collection of brands we've helped forge — from zero-to-launch
              identities to full Shopify rebuilds. 150+ projects. 60+ brands. 5
              years obsessing.
            </p>
          </ScrollReveal>
        </div>
      </section>

      <PortfolioGrid />
      <StatsMarquee />
      <CTASection />
    </div>
  );
}
